<template>
  <section>
    <navbar-dashboard name="Editar seguro"></navbar-dashboard>

    <section class="ew-smaller-container">
      <div class="ew-card">
        <p class="ew-hint">
          Las paqueterías cubren hasta $2,000.00 MXN, su garantía es limitada (no cubre robos ni riesgos de tránsito). Por esa razón te recomendamos adquirir nuestro seguro adicional. Puedes calcular su costo a continuación:
        </p>

        <form class="ew-form" @submit.prevent="updateShipment">
          <div class="ew-form__row" v-if="package_insurance === 'true'">
            <div class="ew-form__field">
              <label class="ew-label" for="esi-value">Valor del paquete</label>
              <input id="esi-value" type="text" class="ew-input ew-input--block" v-model="insurance_information.package_value" required>
            </div>
            <div class="ew-form__field">
              <label class="ew-label" for="esi-responsible">Responsable del paquete</label>
              <input id="esi-responsible" type="text" class="ew-input ew-input--block" v-model="insurance_information.responsible_for_the_package" required>
            </div>
            <div class="ew-form__field">
              <label class="ew-label" for="esi-email">Correo de contacto</label>
              <input id="esi-email" type="text" class="ew-input ew-input--block" v-model="insurance_information.mail_responsible" required>
            </div>
            <div class="ew-form__field">
              <label class="ew-label" for="esi-cost">Costo del seguro</label>
              <input id="esi-cost" type="text" class="ew-input ew-input--block" v-model="insurance_information.cost" required>
            </div>
          </div>

          <label class="ew-checkbox-row">
            <input type="radio" value="false" v-model="package_insurance" required name="package_insurance">
            <span>No deseo adquirir seguro adicional</span>
          </label>
          <label class="ew-checkbox-row">
            <input type="radio" value="true" v-model="package_insurance" required name="package_insurance">
            <span>Adquirir seguro adicional</span>
          </label>

          <div class="ew-form__actions">
            <router-link class="ew-btn-outline" :to="'/shipments/' + $route.params['id']">Cancelar</router-link>
            <button class="ew-btn-primary" type="submit">Aplicar cambios</button>
          </div>
        </form>
      </div>
    </section>

  </section>
</template>

<script>
import axios from 'axios'
import commons from '../../commons'
import api from '../../commons/api'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import Navbar from '../Header/Navbar'

export default {
  name: 'EditShipmentDestination',
  data () {
    return {
      step: 1,

      selectedShippingOptionIndex: -1,

      origin_direction: {
        full_name: '',
        email: '',
        phone: '',
        address: '',
        reference_of_origin: '',
        colony: '',
        postal_code: '',
        state_code: '',
        city: '',
        country_code: 'MX'
      },

      destination_direction: {
        full_name: '',
        email: '',
        phone: '',
        address: '',
        reference_of_origin: '',
        colony: '',
        postal_code: '',
        state_code: '',
        city: '',
        country_code: 'MX'
      },

      description_of_the_content: '',
      package_insurance: false,

      insurance_information: {
        package_value: null,
        responsible_for_the_package: null,
        mail_responsible: null,
        cost: null
      },

      parcels: [
        {
          depth: '',
          width: '',
          height: '',
          weight: ''
        }
      ],

      requestBody: {
        origin_direction: {
          country_code: '',
          postal_code: '',
          city: '',
          suburb: ''
        },

        parcels: [
          {
            weight: '',
            height: '',
            depth: '',
            width: ''
          }
        ],
        destination_direction: {
          country_code: '',
          postal_code: '',
          city: '',
          suburb: ''
        },
        insured_value: '',
        insured_value_currency: 'MXN'
      }
    }
  },
  methods: {
    updateShipment () {
      this.setSelectedShippingOption(
        this.shippingOptions[this.selectedShippingOptionIndex]
      )

      const requestBody = {
        insurance_information: this.insurance_information
      }

      this.setNewShipmentRequestBody(requestBody)
      api.shipment.update(this.$route.params['id'], requestBody).then(() => {
        this.getAllShipments()
        this.$router.go(-1)
      })
    },

    calculateQuote () {
      console.log('calculateQuote')

      this.requestBody.parcels = this.parcels

      this.requestBody.origin_direction = {
        country_code: this.origin_direction.country_code,
        postal_code: this.origin_direction.postal_code,
        city: this.origin_direction.city,
        suburb: this.origin_direction.colony
      }

      this.requestBody.destination_direction = {
        country_code: this.destination_direction.country_code,
        postal_code: this.destination_direction.postal_code,
        city: this.destination_direction.city,
        suburb: this.destination_direction.colony
      }

      if (this.package_insurance) {
        this.insured_value = this.insurance_information.cost
      } else {
        delete this.insured_value
      }

      this.setQuotingRequestBody(this.requestBody)

      this.quoting()
        .then(() => {
          this.nextStep()
        })
        .catch(error => console.log(error))
    },

    createShipment () {
      this.setSelectedShippingOption(
        this.shippingOptions[this.selectedShippingOptionIndex]
      )

      const requestBody = {
        selected_service: {
          full_name: this.selectedShippingOption.product_short_name,
          mount: this.selectedShippingOption.shipping_charge,
          logo_url: this.selectedShippingOption.logo_url,
          delivery_time: this.selectedShippingOption.delivery_date,
          pickup_date: this.selectedShippingOption.pickup_date,
          currency_code: this.selectedShippingOption.currency_code
        },
        shipment_type: this.quotingRequestBody.shipment_type,
        parcels: this.quotingRequestBody.parcels,
        origin_direction: this.origin_direction,
        destination_direction: this.destination_direction,
        description_of_the_content: this.description_of_the_content,
        package_insurance: this.package_insurance,
        insurance_information: this.insurance_information,
        user: localStorage.getItem('ew-user-id')
      }

      this.setNewShipmentRequestBody(requestBody)
      this.newShipment().then(() => {
        this.getAllShipments()
        this.$router.push('/dashboard')
      })
    },

    checkAddressOrigin (event) {
      // console.log(event)
      const query = event.target.value
      if (query.length >= 3) {
        this.getLocationInfo(query, 'MX').then(response => {
          console.log(response.data)
          this.origin_direction.city =
            response.data[0].parish + ', ' + response.data[0].state
        })
      }
    },
    checkAddressDestination (event) {
      // console.log(event)
      const query = event.target.value
      if (query.length >= 3) {
        this.getLocationInfo(query, 'MX').then(response => {
          // console.log(response.data)
          this.destination_direction.city =
            response.data[0].parish + ', ' + response.data[0].state
        })
      }
    },
    getLocationInfo (zipCode, countryCode) {
      return axios.get(
        `${
          commons.apiURL
        }/api/v1/postalcode?zipCode=${zipCode}&country=${countryCode}`
      )
    },
    ...mapMutations([
      'netNewShipmentRequestBody',
      'setQuotingRequestBody',
      'setSelectedShippingOption',
      'setNewShipmentRequestBody'
    ]),
    ...mapActions(['quoting', 'newShipment', 'getAllShipments'])
  },
  computed: {
    currentStep () {
      return this.step
    },
    ...mapGetters([
      'quotingRequestBody',
      'selectedShippingOption',
      'serviceProviders',
      'shippingOptions'
    ])
  },
  created () {
    api.shipment.getByID(this.$route.params['id']).then(response => {
      this.insurance_information = response.data.insurance_information
    })
  },
  components: {
    'navbar-dashboard': Navbar
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/styles/app-tokens";
@import "../../assets/styles/ew-components";

.ew-smaller-container { @include app-tokens; max-width: 600px; margin: 2.5rem auto; padding: 0 1rem 4rem; }
.ew-card { @include ew-card; padding: 1.5rem 1.75rem; }
.ew-btn-primary { @include ew-btn-primary; }
.ew-btn-outline { @include ew-btn-outline; }
.ew-form { display: flex; flex-direction: column; gap: 0.75rem; max-width: none; }
.ew-form__row { display: flex; flex-wrap: wrap; gap: 1rem; margin-bottom: 0.5rem; > .ew-form__field { flex: 1 1 220px; min-width: 0; } }
.ew-form__field { display: flex; flex-direction: column; gap: 0.4rem; }
.ew-form__actions { display: flex; justify-content: flex-end; gap: 0.6rem; margin-top: 0.5rem; }
.ew-label { font-family: var(--app-font); font-size: 0.8rem; font-weight: 700; color: var(--app-navy); }
.ew-input { @include ew-input; }
.ew-input--block { width: 100%; }
.ew-hint { font-family: var(--app-font); color: var(--app-navy-secondary); font-size: 0.9rem; margin-bottom: 1.25rem; }
.ew-checkbox-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  font-family: var(--app-font);
  font-size: 0.9rem;
  color: var(--app-navy-secondary);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/editShipment/EditShipmentInsurance.vue